import { render, staticRenderFns } from "./tabRailwayBookingUICustom.vue?vue&type=template&id=15840b0f&scoped=true&"
import script from "./tabRailwayBookingUICustom.vue?vue&type=script&lang=js&"
export * from "./tabRailwayBookingUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabRailwayBookingUICustom.vue?vue&type=style&index=0&id=15840b0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15840b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15840b0f')) {
      api.createRecord('15840b0f', component.options)
    } else {
      api.reload('15840b0f', component.options)
    }
    module.hot.accept("./tabRailwayBookingUICustom.vue?vue&type=template&id=15840b0f&scoped=true&", function () {
      api.rerender('15840b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/remoteBooking/tabs/tabRailwayBookingUICustom.vue"
export default component.exports